module.exports = __webpack_public_path__ + "static/media/Chaco.d058ee69.svg";